import request from '../../request';

class ObservationsClient {
    static getObservations = url => request.get(url);
}

export default ObservationsClient;
